export enum SyncType {
  NEW_CONTENT_AVAILABLE = "NEW_CONTENT_AVAILABLE",
  SKIP_WAITING = "SKIP_WAITING",
  RELOAD_OTHER_TABS = "RELOAD_OTHER_TABS",
}
